export const AboutVideo = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-royal-deep py-24 lg:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        {/* Section header */}
        <div className="mb-12 lg:mb-16">
          <p className="text-[11px] tracking-[0.32em] uppercase text-lavender mb-4">
            01 — The Candidate
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Text — LEFT */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <h2
              data-testid="about-heading"
              className="font-serif-display text-classy text-5xl sm:text-6xl lg:text-7xl leading-[0.95] mb-4 font-medium"
            >
              Meet <span className="italic font-light">Sikaiadah</span> Newton
            </h2>
            <p className="font-serif-display italic text-lavender text-xl sm:text-2xl lg:text-3xl mb-8">
              Educator, Mentor, and Voice of Ward 3.
            </p>

            <p className="text-classy-soft/90 leading-relaxed text-[15px] lg:text-base mb-10">
              Born and raised in the 757, Sikaiadah "Si" Newton is a Norfolk native
              whose Virginia roots run deep and whose purpose runs deeper. An
              educator, mentor, author, martial arts and aquatic instructor, and
              president of both a civic league and auxiliary nonprofit, Si has
              built a life of service that spans every corner of this community.
              She pours into her neighbors, her students, and the next generation
              not because it is her job, but because it is her calling. Now, she
              is channeling that same tireless commitment into Ward 3, running for
              Norfolk City Council to ensure every community has access to
              affordable housing, economic opportunity, quality education, and
              healthcare. Because when we invest in our community and uplift our
              residents we all grow together.
            </p>

            <div className="divider-line my-10"></div>

            <blockquote
              data-testid="candidate-statement"
              className="space-y-5 text-classy-soft/90 text-[15px] lg:text-base leading-relaxed border-l-2 border-lavender/50 pl-6"
            >
              <p>
                "Ward 3 is ready to be heard. We have communities that need
                affordable housing, economic opportunity, quality education,
                and accessible healthcare — and we deserve a representative
                who listens to all of us, not just certain parts of the
                ward."
              </p>
              <p>
                "I, Sikaiadah Newton, am running for Norfolk City Council
                Ward 3 because{" "}
                <span className="font-serif-display italic text-lavender text-lg sm:text-xl">
                  Community Is Our Power.
                </span>{" "}
                I won't show up with all the answers — I'll show up with
                you. Together, we identify the challenges, and together, we
                grow."
              </p>
              <p className="font-serif-display italic text-classy text-2xl sm:text-3xl leading-tight pt-2">
                "I won't lead for you. I will lead with you."
              </p>
              <p className="font-serif-display italic text-lavender text-lg sm:text-xl">
                Together We Grow Ward 3 with Sikaiadah Newton.
              </p>
              <footer className="pt-2 text-[11px] tracking-[0.28em] uppercase text-classy-soft/70">
                — Sikaiadah Newton
              </footer>
            </blockquote>

            <a
              href="#get-involved"
              data-testid="about-cta-meet"
              className="btn-classy inline-flex mt-10 px-8 py-3.5 rounded-full text-xs uppercase"
            >
              Stand With Si
            </a>
          </div>

          {/* Photo — RIGHT */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div
              data-testid="about-photo"
              className="relative w-full aspect-[4/5] overflow-hidden rounded-sm border border-lavender/15"
            >
              <img
                src="/assets/headshot.png"
                alt="Sikaiadah Newton — Candidate for Norfolk City Council, Ward 3"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#1B0640]/35 via-transparent to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase text-classy bg-[#1B0640]/70 backdrop-blur px-3 py-1.5 rounded-full">
                  Sikaiadah Newton
                </span>
                <span className="text-[10px] tracking-[0.3em] uppercase text-classy bg-[#1B0640]/70 backdrop-blur px-3 py-1.5 rounded-full">
                  Ward 3
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutVideo;
